import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const QUERY_KEY = 'getAvailableEmailNotificationTemplates';

export const useGetAvailableEmailNotificationTemplatesQuery = (
  notificationType?: string,
  userRole?: string
) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEY, userRole, notificationType],
    userRole && notificationType
      ? () =>
          api.get(API_URL.EXTERNAL_TEMPLATES_AVAILABLE, {
            params: {
              ...(userRole ? { user_type: userRole } : {}),
              ...(notificationType ? { notification_type: notificationType } : {}),
            },
          })
      : () => null,
    {
      cacheTime: 0,
    }
  );

  const formattedOptions = useMemo(() => {
    return data?.data.map((item) => ({
      key: `${item.id}`,
      value: `${item.id}`,
      title: item.template_description,
    }));
  }, [data]);

  return {
    data: data?.data,
    formattedOptions,
    isLoading,
  };
};
